<template>
  <div class="c-app-notify-container">
    <component v-if="notifyComponent" :is="notifyComponent" :visible="visible" @close="onClose" />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, useHostAppInstance } from '@zto/zpage'

const app = useHostAppInstance()

const notifyConfig = app.useAppConfig('header.notify')

const notifyComponent = notifyConfig.component || app.resolveComponent('CAppNotifyPanel')

// 定义组件的props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  }
})

// 定义向外发出的事件
const emit = defineEmits(['close'])

// 处理关闭事件
const onClose = () => {
  emit('close')
}
</script>

<style lang="scss" scoped>
.c-app-notify-container {
  height: calc(100vh - var(--app-header-height));
}
</style>
